import { useTranslation } from 'react-i18next';
import { type IPagination } from './Pagination';

const PAGE_TYPE = {
    NOMAL: 'nomal',
    FRONT: 'front',
    END: 'end',
    CENTER: 'center',
};

const BtnItem = ({ idx, current, pageGo }: { idx: number; current: number; pageGo: (pageNum: string, toTop?: boolean) => void }) => {
    const onNumberClick = () => pageGo(idx.toString(), true);

    if (current === idx) return <span className="number current">{idx}</span>;
    if (current !== idx)
        return (
            <button onClick={onNumberClick} className="number">
                {idx}
            </button>
        );
};

export const PaginationPc = ({ dat, pageGo }: { dat: IPagination; pageGo: (pageNum: string, toTop?: boolean) => void }) => {
    const { t } = useTranslation();

    if (!dat || dat.lastPage < 2) return null;

    const onPrev = () => pageGo(Math.max(dat.page - 5, 1).toString(), true);
    const onNext = () => pageGo(Math.min(dat.page + 5, dat.lastPage).toString(), true);

    let pagetype = PAGE_TYPE.NOMAL;
    if (dat.lastPage > 10) {
        if (dat.page < 6) {
            pagetype = PAGE_TYPE.END;
        }
        if (dat.page > dat.lastPage - 5) {
            pagetype = PAGE_TYPE.FRONT;
        }
        if (dat.page > 5 && dat.page < dat.lastPage - 4) {
            pagetype = PAGE_TYPE.CENTER;
        }
    }

    return (
        <div className="ui-pagination is-pc">
            <div className="pagination-list">
                {dat.page < 6 ? (
                    <button className="prev is-disabled" title="">
                        <span>{t('price.prev')}</span>
                    </button>
                ) : (
                    <button onClick={onPrev} className="prev" title="Prev 5 pages">
                        <span>{t('price.prev')}</span>
                    </button>
                )}

                {pagetype === PAGE_TYPE.NOMAL && (
                    <>
                        {Array.from({ length: dat.lastPage }).map((_, i) => (
                            <BtnItem key={i + 1} idx={i + 1} current={dat.page} pageGo={pageGo} />
                        ))}
                    </>
                )}

                {pagetype === PAGE_TYPE.END && (
                    <>
                        {Array.from({ length: 7 }).map((_, i) => (
                            <BtnItem key={i + 1} idx={i + 1} current={dat.page} pageGo={pageGo} />
                        ))}
                        <span className="delimiter">...</span>
                        <BtnItem idx={dat.lastPage} current={dat.page} pageGo={pageGo} />
                    </>
                )}

                {pagetype === PAGE_TYPE.FRONT && (
                    <>
                        <BtnItem idx={1} current={dat.page} pageGo={pageGo} />
                        <span className="delimiter">...</span>
                        {Array.from({ length: 7 }).map((_, i) => (
                            <BtnItem key={dat.lastPage - 6 + i} idx={dat.lastPage - 6 + i} current={dat.page} pageGo={pageGo} />
                        ))}
                    </>
                )}

                {pagetype === PAGE_TYPE.CENTER && (
                    <>
                        <BtnItem idx={1} current={dat.page} pageGo={pageGo} />
                        <span className="delimiter">...</span>
                        {Array.from({ length: 5 }).map((_, i) => (
                            <BtnItem key={dat.page - 2 + i} idx={dat.page - 2 + i} current={dat.page} pageGo={pageGo} />
                        ))}
                        <span className="delimiter">...</span>
                        <BtnItem idx={dat.lastPage} current={dat.page} pageGo={pageGo} />
                    </>
                )}

                {dat.page >= dat.lastPage - 4 ? (
                    <button className="next is-disabled" title="">
                        <span>{t('price.next')}</span>
                    </button>
                ) : (
                    <button onClick={onNext} className="next" title="Next 5 pages">
                        <span>{t('price.next')}</span>
                    </button>
                )}
            </div>
        </div>
    );
};
